import * as actions from "../../../../../../redux/actions/flowsActions";

export const onAddUserAttachment = async (dispatch, axis, id) => {
  const newNodeId = Date.now().toString();
  const newNode = {
    id: newNodeId,
    type: "user-attachment",
    data: { label: "User Attachment" },
    position: axis,
    fieldData: [],
    isUser: true,
  };

  const edge = {
    id: Date.now(),
    source: id,
    target: newNodeId,
    style: {
      strokeWidth: 2.2,
      stroke: "#566e8a",
    },
    type: "smoothstep",
  };

  await dispatch({
    type: actions.CURRENT_NODE_ID,
    payload: { nodeId: newNodeId },
  });
  dispatch({ type: actions.ADD_NODE, payload: { newNode, nodeId: id } });
  dispatch({ type: actions.ADD_EDGE, payload: edge });
  dispatch({ type: actions.SIDEBAR_USER_ATTACHMENT, payload: true });
};
